<div>
  <div class="card border-secondary mb-6" style="max-width: 100%;">
    <div class="card-header">
      <span>
        <span (click)="descriptionElement.toggle()">
          <i
            class="fa fa-lg fa-plus-square"
            *ngIf="!descriptionElement.collapse"
          ></i>
          <i
            class="fa fa-lg fa-minus-square"
            *ngIf="descriptionElement.collapse"
          ></i>
        </span>
      </span>
      ag-grid
    </div>
    <div
      class="card-body text-secondary"
      #descriptionElement="bs-collapse"
      [collapse]="false"
    >
      <h4 class="card-title">ag-gridで色々実験するサンプル</h4>
      <div class="card-text">
        <ul>
          <li>
            <span>スペース</span>
            <p>リンクのRenderer. 現状動作してない...</p>
          </li>
          <li>
            <span>開始日</span>
            <p>datepickerで日付を編集できる</p>
            <p>cellEditorFrameworkでコンポーネントを呼び出し</p>
            <p>デフォルトの日付フィルタ</p>
          </li>
          <li>
            <span>check</span>
            <p>
              gridでの表示をRendererでカスタマイズしHTMLを返すようにしている
            </p>
            <p>CSVでDLして見るとデータだけが見えるようになっている</p>
            <p>
              カスタムフィルタ.
              objectに対して対象キーの値(boolena)に対してフィルタを掛けられる
            </p>
          </li>
          <li>
            <span>price</span>
            <p>gridOptions.contextに状態をもたせて編集後に比較する</p>
            <p>colDef.cellClassRuleで差分があればクラスを当てる</p>
            <p>数値のフィルタ</p>
          </li>
          <li>
            <span>data</span>
            <p>json</p>
            <p>JSONに対してキーが存在するものだけフィルタする機能</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<button
  type="button"
  class="btn btn-sm btn-outline-primary"
  (click)="downloadCsv()"
>
  Download CSV
</button>

<button
  type="button"
  class="btn btn-sm btn-outline-secondary"
  (click)="clearFilter()"
>
  Reset Filter
</button>

<div class="flex-container">
  <ag-grid-angular
    #sampleGrid
    class="ag-theme-balham grid"
    [gridOptions]="gridOptions"
    [rowData]="rowData"
    [rowHeight]="35"
    [rowSelection]="'multiple'"
    [rowMultiSelectWithClick]="true"
    [suppressRowClickSelection]="false"
    [columnDefs]="columnDefs"
    (cellValueChanged)="valueChanged($event)"
    (cellEditingStopped)="editted($event)"
    (sortChanged)="sortChanged($event)"
    (filterChanged)="filterChanged($event)"
  >
  </ag-grid-angular>
</div>
